export default __webpack_public_path__ + "static/media/fireAI-Logo-Medium.ef8b946a.webp";